import script from "./QuestItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestItem.vue?vue&type=script&setup=true&lang=js"

import "./QuestItem.vue?vue&type=style&index=0&id=1efdc554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efdc554"]])

export default __exports__